import coinsC from 'assets/illustrations/vxl/coins-c.png';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, ImageSourcePropType, StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodySmBoldText from 'shared/components/vxl/typography/primary/body/BodySmBoldText';
import theme from 'shared/styles/theme';

interface NoTransactionsProps {
  title: string;
}

const NoTransactions = ({ title }: NoTransactionsProps) => {
  const { t: translatedText } = useTranslation('accounts', {
    keyPrefix: 'transactions',
  });

  return (
    <View style={styles.container}>
      <BodySmBoldText numberOfLines={0} style={styles.title}>
        {title}
      </BodySmBoldText>
      <Image
        source={coinsC as ImageSourcePropType}
        style={styles.image}
        testID="no-transactions-image"
      />
      <BodyBaseText numberOfLines={0} style={styles.bodyText}>
        {translatedText('activity')}
      </BodyBaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  bodyText: {
    color: theme.color.text.secondary,
  },
  container: {
    alignItems: 'center',
    backgroundColor: theme.color.background.primary,
    display: 'flex',
    gap: 16,
    height: 380,
    padding: 16,
  },
  image: {
    height: 131,
    width: 131,
  },
  title: {
    alignSelf: 'flex-start',
  },
});

export default NoTransactions;
